import * as yup from 'yup';
import { createAsyncThunk, createSlice, isAllOf, isAnyOf } from "@reduxjs/toolkit";
import { hidePreLoader, showPreLoader } from '../../../loader/loaderSlice';
import customerApiRequest from '../../../../app/api/customer/customerApiRequest';


interface CustomerState {
    getCustomerReword: any;
    searchCustomerRewordByParam: any;
    currentMonthExpiringLoyaltyPoints: any;
    loyaltyBehaviorSetup: any;
}
const initialState: CustomerState = {
    getCustomerReword: null,
    searchCustomerRewordByParam: [],
    currentMonthExpiringLoyaltyPoints: null,
    loyaltyBehaviorSetup: null
}

export const getCustomerReword = createAsyncThunk<any, { customerId: number , pageNumber : number}>(
    'WebAccessCustomer/getCustomerReword',
    async ({ customerId , pageNumber}, thunkAPI) => {
        try {
            const GetCustomerReword = await customerApiRequest.getCustomerReword(customerId ,pageNumber);
            return GetCustomerReword;
        } catch (error: any) {
            return thunkAPI.rejectWithValue({ error: error.data });
        }
    }
)

export const searchCustomerRewordByParam = createAsyncThunk<any, { requestData: any }>(
    'WebAccessCustomer/searchCustomerRewordByParam',
    async ({ requestData }, thunkAPI) => {
        try {        
            const searchCustomerRewordByParam = await customerApiRequest.searchCustomerRewordByParam(requestData);
            return searchCustomerRewordByParam;
        } catch (error: any) {
            return thunkAPI.rejectWithValue({ error: error.data });
        }
    }
)

export const generateLoyaltyRewardCardPdf = createAsyncThunk<any, { customerId: any }>(
    'WebAccessCustomer/generateLoyaltyRewardCardPdf',
    async ({ customerId }, thunkAPI) => {
        try {
            let res = null;
            res = await customerApiRequest.generateLoyaltyRewardCardPdf(customerId);
            thunkAPI.dispatch(hidePreLoader());
            if (res?.$values && res?.$values?.length > 0 && res?.$values[0]?.Data) {
                if (res.$values[0].Data) {
                    var binary_string = (window as any).atob(res.$values[0].Data);
                    var len = binary_string.length;
                    var bytes = new Uint8Array(len);
                    for (var i = 0; i < len; i++) {
                        bytes[i] = binary_string.charCodeAt(i);
                    }
                    var blob = new Blob([bytes.buffer], { type: 'application/pdf' });
                    var url = window.URL.createObjectURL(blob);
                    thunkAPI.dispatch(hidePreLoader());
                    const width = window.innerWidth;
                    const height = window.innerHeight;
                    const features = `width=${width},height=${height}`;
                    window.open(url, "_blank", features);
                } else {
                }
            }
            else {
            }
        } catch (error: any) {
            return thunkAPI.rejectWithValue({ error: error.data });
        }
    }
)

export const getCurrentMonthExpiringLoyaltyPoints = createAsyncThunk<any, { customerId: number}>(
    'WebAccessCustomer/getCurrentMonthExpiringLoyaltyPoints',
    async ({ customerId }, thunkAPI) => {
        try {
            const currentMonthExpiringLoyaltyPoints = await customerApiRequest.getCurrentMonthExpiringLoyaltyPoints(customerId);
            return currentMonthExpiringLoyaltyPoints;
        } catch (error: any) {
            return thunkAPI.rejectWithValue({ error: error.data });
        }
    }
)

export const getLoyaltyBehaviorSetup = createAsyncThunk<any>(
    'WebAccessCustomer/getLoyaltyBehaviorSetup',
    async (_, thunkAPI) => {
        try {
            const loyaltyBehaviorSetup = await customerApiRequest.getLoyaltyBehaviorSetup();
            return loyaltyBehaviorSetup;
        } catch (error: any) {
            return thunkAPI.rejectWithValue({ error: error.data });
        }
    }
)

export const CustomerRewadsSlice = createSlice({
    name: 'CustomerRewads',
    initialState,
    reducers: {
        setCustomerReword: (state, action) => {
            state.getCustomerReword = action.payload
        },
        setsearchCustomerRewordByParam: (state, action) => {
            state.searchCustomerRewordByParam = action.payload
        },

    },
    extraReducers: (builder => {
        builder.addCase(searchCustomerRewordByParam.rejected, (state) => {
            state.searchCustomerRewordByParam = [];
        });
        builder.addCase(getCustomerReword.rejected, (state) => {
            state.getCustomerReword = [];
        });
        builder.addCase(getCurrentMonthExpiringLoyaltyPoints.rejected, (state) => {
            state.currentMonthExpiringLoyaltyPoints = null;
        });
        builder.addCase(getLoyaltyBehaviorSetup.rejected, (state) => {
            state.loyaltyBehaviorSetup = null;
        });

        builder.addMatcher(isAnyOf(getCustomerReword.fulfilled), (state, action) => {
            state.getCustomerReword = action.payload;
        });
        builder.addMatcher(isAnyOf(getCurrentMonthExpiringLoyaltyPoints.fulfilled), (state, action) => {
            state.currentMonthExpiringLoyaltyPoints = action.payload;
        });
        builder.addMatcher(isAnyOf(getLoyaltyBehaviorSetup.fulfilled), (state, action) => {
            state.loyaltyBehaviorSetup = action.payload;
        });
    })
})
export const { setCustomerReword, setsearchCustomerRewordByParam } = CustomerRewadsSlice.actions;